import { Pair } from "./comparison";

function pairQuery(pair?: Partial<Pair>): string {
  if (!pair) {
    return "";
  }
  const candidate = pair.candidate ? `&cand=${pair.candidate}` : "";
  const baseline = "baseline" in pair ? `&base=${pair.baseline ?? ""}` : "";
  return candidate + baseline;
}

export function setPath(testSetId: string, pair?: Partial<Pair>) {
  return `?tab=tests&set=${testSetId}${pairQuery(pair)}`;
}

export function testPath(
  testSetId: string,
  testId: string,
  pair?: Partial<Pair>
) {
  return `?tab=tests&set=${testSetId}&test=${testId}${pairQuery(pair)}`;
}

export function userMessages(inputs: Record<string, unknown>): string[] {
  const messages = inputs.messages;
  if (!Array.isArray(messages)) {
    return [];
  }
  return messages.filter((m): m is string => typeof m === "string");
}
